import { useEffect, useMemo } from "react";
import Modal from "../../Modal";
import ConsentHistory from "./ConsentHistory";
import GeneralInformation from "./GeneralInformation";
import Tabs from "../../Tabs";
import styles from "./moreInfo.module.css";
import useLastModifiedUsers from "./useLastModifiedUsers";
import { getUserById } from "../../../utils/utils";
const MoreInfoHistoryPopUp = ({
  isProfileHistoryOpen,
  setIsProfileHistoryOpen,
  loading,
  setSelectedData,
  digitalIdentity,
  history,
  historyInfo,
}) => {
  const { modifiedUsers, loader } = useLastModifiedUsers({
    history,
    historyInfo,
  });

  const handleModalOpen = (status) => {
    setSelectedData();
    setIsProfileHistoryOpen(status);
  };

  useEffect(() => {
    if (modifiedUsers?.length) {
      if (historyInfo?.last_modified_by_id && !historyInfo?.lastModifiedBy) {
        const lastModifiedBy = getUserById(
          modifiedUsers,
          historyInfo?.last_modified_by_id
        );
        if (lastModifiedBy?.id) {
          setSelectedData({ ...historyInfo, lastModifiedBy: lastModifiedBy });
        }
      }
      if (history?.length) {
        history = [];
      }
    }
  }, [modifiedUsers, loader]);
  const historyWithModifiedusers = useMemo(() => {
    if (history?.length) {
      return history?.map((data) => ({
        ...data,
        lastModifiedBy: getUserById(modifiedUsers, data?.last_modified_by_id),
      }));
    }
  }, [modifiedUsers]);
  const items = [
    {
      key: "gen-info",
      label: "General Information",
      children: (
        <GeneralInformation
          generalInfoData={historyInfo}
          loader={loader}
          digitalIdentity={digitalIdentity}
        />
      ),
    },
    {
      key: "consent-history",
      label: "Consent History",
      children: (
        <ConsentHistory
          loading={loading}
          digitalIdentity={digitalIdentity}
          info={historyInfo}
          history={historyWithModifiedusers}
        />
      ),
    },
  ];

  return (
    <Modal
      title="Purpose Details and History"
      open={isProfileHistoryOpen}
      setOpen={handleModalOpen}
      okText=""
      canelText=""
      type="profile-history"
      noActions={true}
      tabs={true}
      bodyStyle={styles["modal-body"]}
    >
      <Tabs
        items={items}
        containerStyles={styles["tabs-container"]}
        buttonsStyles={styles["tabs-buttons"]}
        buttonStyle={styles["tab-button"]}
        activeButtonStyle={styles["active"]}
        contentStyles={styles["tabs-content"]}
      />
    </Modal>
  );
};

export default MoreInfoHistoryPopUp;
